import { IconSvg } from './IconSvg';

export function MasterCard() {
    return (
        <IconSvg>
            <path fill="#FF5F00" d="M23.095 3.49H15.93v12.836h7.165" />
            <path
                d="M16.382 9.91c0-2.61 1.23-4.922 3.117-6.42-1.39-1.087-3.14-1.745-5.05-1.745-4.528 0-8.19 3.65-8.19 8.164 0 4.51 3.662 8.162 8.19 8.162 1.91 0 3.66-.657 5.05-1.746-1.89-1.474-3.118-3.81-3.118-6.417z"
                fill="#EB001B"
            />
            <path
                d="M32.76 9.91c0 4.51-3.664 8.162-8.19 8.162-1.91 0-3.662-.657-5.05-1.746 1.91-1.496 3.116-3.81 3.116-6.417 0-2.61-1.228-4.922-3.116-6.42 1.388-1.087 3.14-1.745 5.05-1.745 4.526 0 8.19 3.674 8.19 8.164z"
                fill="#F79E1B"
            />
        </IconSvg>
    );
}
